module.exports = __webpack_public_path__ + "img/flow.bf59368b.png";